var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-edit" },
    [
      _c(
        "subscription",
        _vm._b(
          {},
          "subscription",
          { subscription: _vm.subscription, buttons: false },
          false
        )
      ),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "btn--primary",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.cancel.apply(null, arguments)
              }
            }
          },
          [_vm._v("Cancel Order")]
        )
      ]),
      _c("div", { staticClass: "subtitle" }, [_vm._v("Order Summary")]),
      _c("div", { staticClass: "info-block" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "left" }, [
            _vm._v(_vm._s(_vm.subscription.product_title)),
            _vm.subscription.quantity > 1
              ? _c("span", [_vm._v(_vm._s(" x " + _vm.subscription.quantity))])
              : _vm._e()
          ]),
          _c("div", { staticClass: "right" }, [
            _vm._v(
              "$" +
                _vm._s(_vm.subscription.price) +
                " " +
                _vm._s(_vm.subscription.presentment_currency)
            )
          ])
        ]),
        _c("hr"),
        _vm.charge
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "left" }, [_vm._v("Subtotal")]),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  "$" +
                    _vm._s(_vm.charge.subtotal_price) +
                    " " +
                    _vm._s(_vm.subscription.presentment_currency)
                )
              ])
            ])
          : _vm._e(),
        _vm.charge
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "left" }, [
                _vm._v(
                  "Shipping (" +
                    _vm._s(_vm.charge.shipping_lines[0].title) +
                    ")"
                )
              ]),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  "$" +
                    _vm._s(_vm.charge.shipping_lines[0].price) +
                    " " +
                    _vm._s(_vm.subscription.presentment_currency)
                )
              ])
            ])
          : _vm._e(),
        _vm.charge
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "left" }, [_vm._v("Estimated Taxes")]),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  "$" +
                    _vm._s(_vm.charge.total_tax) +
                    " " +
                    _vm._s(_vm.subscription.presentment_currency)
                )
              ])
            ])
          : _vm._e(),
        _c("hr"),
        _vm.charge
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "left" }, [_vm._v("Estimated Total")]),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  "$" +
                    _vm._s(_vm.subscription.price) +
                    " " +
                    _vm._s(_vm.subscription.presentment_currency)
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm.charge && _vm.charge.shipping_address
        ? _c("div", { staticClass: "div" }, [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("Shipping Address")
            ]),
            _c("div", { staticClass: "info-block" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "left" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.charge.shipping_address.first_name) +
                        " " +
                        _vm._s(_vm.charge.shipping_address.last_name)
                    )
                  ]),
                  _c("p", [
                    _vm._v(_vm._s(_vm.charge.shipping_address.address1))
                  ]),
                  _vm.charge.shipping_address.address2
                    ? _c("p", [
                        _vm._v(_vm._s(_vm.charge.shipping_address.address2))
                      ])
                    : _vm._e(),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.charge.shipping_address.city) +
                        ", " +
                        _vm._s(_vm.charge.shipping_address.province) +
                        ", " +
                        _vm._s(_vm.charge.shipping_address.zip)
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }